import { useTranslation } from 'react-i18next';
import useSetTitle from '~/hooks/useSetTitle';
import { SectionNumber } from '../constants';
import { SectionNumberObj } from '../interfaces';
import { PGSectionNumber } from '../providerGroups/constants';

export const useTabTitle = <Sect extends SectionNumber | PGSectionNumber>(
  sectionValue: Sect,
  section: SectionNumberObj<Sect>
): void => {
  const { t } = useTranslation(
    section === PGSectionNumber ? 'providerGroupPaperwork' : 'paperwork'
  );
  const sectionTitle = t(`${sectionValue}.sectionTitle` as any);
  useSetTitle(`Paperwork - ${sectionTitle}`);
  return;
};
